import type { MessageStudentsProps } from '../pages/Home/modules/MessageStudents';
import React, { useEffect, useState } from 'react';
import { MessageStudents } from '../pages/Home/modules';
import { useModal } from './useModal';
import { useI18n } from '@whizz/react-i18n';

export const useMessages = (closeCallback?: () => void): [ JSX.Element, React.Dispatch<React.SetStateAction<Pick<MessageStudentsProps, 'students' | 'type'>>> ] => {
  const { translate } = useI18n();
  const [ messageStudents, setMessageStudents ] = useState<Pick<MessageStudentsProps, 'students' | 'type'>>({ students: [] });

  const [ modal, toggle, setProps ] = useModal((props: MessageStudentsProps) => (
    <MessageStudents {...props} />
  ), {}, () => setMessageStudents({ students: [] }));

  useEffect(() => {
    if (messageStudents?.students.length > 0) {
      setProps({
        title: translate('pages.HOME.MESSAGE_STUDENTS.TITLE'),
        students: messageStudents.students,
        type: messageStudents.type,
        closeCallback: () => {
          setMessageStudents({ students: [] });
          closeCallback?.();
        },
      });
      toggle(true);
    }
  }, [ messageStudents ]);

  return [ modal, setMessageStudents ];
};
